<div class="mx-medium mt-20px flex flex-col h-34px">
    <div class="flex flex-row">
        @for (item of controller.steps; track item; let num = $index) {
            <div
                role="progressbar"
                class="w-full h-3px rounded bg-petroleum10pct mr-3px"
                [ngClass]="{
                    'bg-green':
                        activeStepOnly
                            ? num === controller.currentStepIndex
                            : num <= controller.currentStepIndex,
                }"
            ></div>
        }
    </div>

    <div class="flex flex-row mt-10px">
        @for (item of controller.steps; track item; let num = $index) {
            <span
                role="label"
                class="w-full h-3px body-small text-petroleum70pct relative"
                [ngClass]="{
                    'text-darkGreen body-small-header': num === controller.currentStepIndex,
                    'opacity-0 md:opacity-100': num !== controller.currentStepIndex,
                }"
            >
                <span class="info" [class.last]="num === controller.steps.length - 1"
                    >{{ num + 1 }}. {{ item | translate }}</span
                >
            </span>
        }
    </div>
</div>
